import React from 'react'
import { Tooltip } from 'antd'
import { HistoryOutlined } from '@ant-design/icons'
import { useIntl } from 'react-intl'

function formatTotalIssuesCount(totalIssuesCount) {
  return totalIssuesCount >= 100 ? '99+' : totalIssuesCount
}

function Button(props) {
  const { totalIssuesCount, hasSameIssuesHistory, openSameIssuesHistory } =
    props
  const intl = useIntl()

  if (!hasSameIssuesHistory) {
    return null
  }

  return (
    <Tooltip title={intl.formatMessage({ id: 'tracer.sameIssues.tooltip' })}>
      <button
        type="button"
        className="same-issues-history-button-container"
        onClick={openSameIssuesHistory}
        data-testid="same-issues-history-button"
        aria-label={intl.formatMessage({ id: 'tracer.sameIssues.tooltip' })}
      >
        <div className="counter">
          {formatTotalIssuesCount(totalIssuesCount)}
        </div>
        <div className="same-issues-history-button">
          <HistoryOutlined />
        </div>
      </button>
    </Tooltip>
  )
}

export default Button
